"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _basePalette = require("./base-palette");
Object.keys(_basePalette).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _basePalette[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _basePalette[key];
    }
  });
});
var _clarityPalette = require("./clarity-palette");
Object.keys(_clarityPalette).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _clarityPalette[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _clarityPalette[key];
    }
  });
});
var _midnightPalette = require("./midnight-palette");
Object.keys(_midnightPalette).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _midnightPalette[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _midnightPalette[key];
    }
  });
});
var _xvantagePalette = require("./xvantage-palette");
Object.keys(_xvantagePalette).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _xvantagePalette[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _xvantagePalette[key];
    }
  });
});